/* eslint-disable import/prefer-default-export */
// filter out __typename before sending to the api
export const omitTypename = obj =>
  ({}.hasOwnProperty.call(obj, '__typename') ? (({ __typename, ...rest }) => rest)(obj) : obj);
